import React, { useEffect, useState } from 'react';
import { Button } from './ui';
import { RefreshCw } from 'lucide-react';

export function PwaReloadPrompt() {
    const [sw, setSw] = useState<any>(null);
    const [offlineReady, setOfflineReady] = useState(false);
    const [needRefresh, setNeedRefresh] = useState(false);

    useEffect(() => {
        // Usamos un import dinámico con una variable para burlar el analizador estático de Vite
        // y evitar que arroje error de resolución de módulo en local cuando VITE_ENABLE_PWA es false.
        if (import.meta.env.VITE_ENABLE_PWA === 'true') {
            const moduleName = 'virtual:pwa-register/react';
            import(/* @vite-ignore */ moduleName)
                .then(({ useRegisterSW }) => {
                    setSw({ useRegisterSW });
                })
                .catch((err) => {
                    console.warn('PWA register module not found:', err);
                });
        }
    }, []);

    // Si PWA no está habilitado o aún no carga, no renderizar nada
    if (!sw) return null;

    return <PwaReloadPromptInternal sw={sw} />;
}

function PwaReloadPromptInternal({ sw }: { sw: any }) {
    const {
        offlineReady: [offlineReady, setOfflineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = sw.useRegisterSW({
        onRegistered(r: ServiceWorkerRegistration | undefined) {
            console.log('SW Registered:', r);
        },
        onRegisterError(error: any) {
            console.log('SW registration error', error);
        },
    });

    const close = () => {
        setOfflineReady(false);
        setNeedRefresh(false);
    };

    if (!offlineReady && !needRefresh) return null;

    return (
        <div className="fixed bottom-4 right-4 z-[9999] max-w-sm m-4">
            <div className="bg-white rounded-xl shadow-2xl border border-border p-5 border-l-4 border-l-blue-500 animate-in fade-in slide-in-from-bottom-4 duration-300">
                <div className="flex gap-4">
                    <div className="bg-blue-100 p-3 rounded-full h-fit">
                        <RefreshCw className="w-5 h-5 text-blue-600" />
                    </div>
                    <div className="flex-1">
                        <h3 className="font-semibold text-text">
                            {offlineReady ? 'App lista para usar offline' : '¡Nueva versión disponible!'}
                        </h3>
                        <p className="text-sm text-text-muted mt-1 leading-relaxed">
                            {offlineReady
                                ? 'La aplicación se ha guardado localmente para funcionar sin internet.'
                                : 'Hay una nueva actualización disponible con mejoras y correcciones.'}
                        </p>
                        <div className="mt-4 flex gap-3">
                            {needRefresh && (
                                <Button
                                    size="sm"
                                    onClick={() => updateServiceWorker(true)}
                                    className="bg-blue-600 hover:bg-blue-700 text-white"
                                >
                                    Actualizar ahora
                                </Button>
                            )}
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={close}
                                className="text-text-muted"
                            >
                                Cerrar
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
